export interface RentCalculation {
  disabled: boolean;
  price?: number;
  kmLimit?: number;
}

export interface DaySpecificRentCalculation extends RentCalculation {
  weekendPrice: {
    disabled: boolean;
    price?: number;
    kmLimit?: number;
  };
}

export interface Data {
  _id?: string;
  name: string;
  number: string;
  bikeVariant: string;
  station: string;
  mfgYear: string;
  speedLimit: string;
  timePenalty: number;
  distancePenalty: number;
  securityDepositAmount: number;
  rentCalculations: {
    halfDay: DaySpecificRentCalculation;
    oneDay: DaySpecificRentCalculation;
    oneWeek: RentCalculation;
    fifteenDays: RentCalculation;
    oneMonth: RentCalculation;
    threeMonths: RentCalculation;
    sixMonths: RentCalculation;
  };
}

export const defaultData = {
  _id: "",
  name: "",
  number: "",
  bikeVariant: "",
  station: "",
  mfgYear: "",
  speedLimit: "",
  timePenalty: 0,
  distancePenalty: 0,
  securityDepositAmount: 0,
  rentCalculations: {
    halfDay: {
      disabled: true,
      price: 0,
      kmLimit: 0,
      weekendPrice: {
        disabled: true,
        price: 0,
        kmLimit: 0,
      },
    },
    oneDay: {
      disabled: true,
      price: 0,
      kmLimit: 0,
      weekendPrice: {
        disabled: true,
        price: 0,
        kmLimit: 0,
      },
    },
    oneWeek: {
      disabled: true,
      price: 0,
      kmLimit: 0,
    },
    fifteenDays: {
      disabled: true,
      price: 0,
      kmLimit: 0,
    },
    oneMonth: {
      disabled: true,
      price: 0,
      kmLimit: 0,
    },
    threeMonths: {
      disabled: true,
      price: 0,
      kmLimit: 0,
    },
    sixMonths: {
      disabled: true,
      price: 0,
      kmLimit: 0,
    },
  },
};

export type RentCalculationKeys =
  | "halfDay"
  | "oneDay"
  | "oneWeek"
  | "fifteenDays"
  | "oneMonth"
  | "threeMonths"
  | "sixMonths";
